<template>
  <!-- Slide Group for width >= 500px -->
  <v-container fluid class="pa-0 d-flex flex-nowrap" v-if="screenWidth >= 500">
    <v-slide-group
      v-model="selectedCard"
      show-arrows
      class="d-flex flex-nowrap"
      style="scroll-behavior: smooth; overflow-x: auto;"
    >
      <v-slide-group-item
        v-for="card in cards"
        :key="card.id"
        v-slot="{ isSelected, toggle }"
        :value="card.id"
      >
        <div class="card-wrapper" @click="toggle">
          <RouterLink
            :to="{ name: 'id-card', params: { id: card.id } }"
            class="text-decoration-none"
          >
            <Card
              :class="isSelected ? 'selected-card' : ''"
              :title="card.title"
              :price="card.current_price"
              :originalPrice="card.previous_price"
              :subtitle="card.short_description"
              :image="card.image"
            />
          </RouterLink>
        </div>
      </v-slide-group-item>
    </v-slide-group>
  </v-container>

  <!-- Carousel for width < 500px -->
  <v-container fluid class="pa-0" v-else>
    <v-carousel v-if="showCarousel" height="auto">
      <v-carousel-item v-for="card in cards" :key="card.id">
        <RouterLink
          :to="{ name: 'id-card', params: { id: card.id } }"
          class="text-decoration-none d-block"
        >
          <Card
            :title="card.title"
            :price="card.current_price"
            :originalPrice="card.previous_price"
            :subtitle="card.short_description"
            :image="card.image"
          />
        </RouterLink>
      </v-carousel-item>
    </v-carousel>
  </v-container>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, nextTick } from "vue";
import Card from "@/components/resuable/Card.vue";
import { HotDeals } from "@/services/apiServices.js";
import { apiConfig } from "@/config/apiConfig";
import banner1 from "@/assets/images/administrator.jpg";

const selectedCard = ref(null);
const cards = ref([]);
const showCarousel = ref(false);
const screenWidth = ref(window.innerWidth);

// const getImage = (item) => {
//   return item ? `${apiConfig.imageUrl}/${item}` : banner1;
// };

import { getCurrentInstance } from 'vue';
const { appContext } = getCurrentInstance();
const getImage = appContext.config.globalProperties.$getImage;

const fetchHotDeals = async () => {
  try {
    const data = await HotDeals();
    cards.value = data;
  } catch (err) {
    console.error("Error fetching hot deals:", err);
  }
};

// Update screenWidth on window resize
const updateScreenWidth = () => {
  screenWidth.value = window.innerWidth;
};

onMounted(async () => {
  await fetchHotDeals();
  await nextTick();
  showCarousel.value = true;

  window.addEventListener("resize", updateScreenWidth);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateScreenWidth);
});
</script>

<style scoped>
.card-wrapper {
  flex: 0 0 auto;
  padding: 10px;
  max-width: 320px;
  min-width: 280px;
  margin: 0 8px;
  box-sizing: border-box;
}

.selected-card {
  border: 2px solid #1976D2;
  box-shadow: 0 0 10px rgba(25, 118, 210, 0.5);
}

::v-deep(.v-window__left .v-btn),
::v-deep(.v-window__right .v-btn) {
  margin-top: 120px;
  z-index: 1;
}

::v-deep(.v-carousel__controls) {
  display: none;
}

::v-deep(.v-window__controls) {
  left: 30%;
  top: 9%;
  position: absolute;
  display: none;
  justify-content: center;
  align-items: center;
  transform: translateY(-50%);
  z-index: 1;
}

::v-deep(.v-window__left),
::v-deep(.v-window__right) {
  background-color: rgba(166, 255, 0, 0.151);
  margin: 0px 10px;
}
</style>
